import { createBrowserRouter, redirect } from "react-router";
import { RootLayout } from "../pages/RootLayout";
import { OnboardingPage } from "../pages/OnboardingPage";
import { VisitorLoginPage } from "../pages/VisitorLoginPage";
import { QrGatewayPage } from "../pages/QrGatewayPage";
import { EntryChooserPage } from "../pages/EntryChooserPage";
import { TicketInvitePage } from "../pages/TicketInvitePage";
import { HomePage } from "../pages/HomePage";
import { CompaniesPage } from "../pages/CompaniesPage";
import { CompanyDetailPage } from "../pages/CompanyDetailPage";
import { CompanyProductsPage } from "../pages/CompanyProductsPage";
import { RepresentativeCardPage } from "../pages/RepresentativeCardPage";
import { ProductDetailPage } from "../pages/ProductDetailPage";
import { MapPage } from "../pages/MapPage";
import { ScanPage } from "../pages/ScanPage";
import { HistoryPage } from "../pages/HistoryPage";
import { VisitorContactPage } from "../pages/VisitorContactPage";
import { BusinessCardPage } from "../pages/BusinessCardPage";
import { ChatsPage } from "../pages/ChatsPage";
import { ProfilePage } from "../pages/ProfilePage";
import { EventsPage } from "../pages/EventsPage";
import { ClaimExhibitorBadgePage } from "../pages/ClaimExhibitorBadgePage";
import { ExhibitorDashboard } from "../pages/ExhibitorDashboard";
import { ExhibitorLeadsPage } from "../pages/ExhibitorLeadsPage";
import { LeadDetailPage } from "../pages/LeadDetailPage";
import { GuidePage } from "../pages/GuidePage";
import { SearchPage } from "../pages/SearchPage";
import { SchedulePage } from "../pages/SchedulePage";
import { SessionDetailPage } from "../pages/SessionDetailPage";
import { FavoritesPage } from "../pages/FavoritesPage";
import { ProductsPage } from "../pages/ProductsPage";
import { SupportChatPage } from "../pages/SupportChatPage";
import { BoothSharePage } from "../pages/BoothSharePage";
import { BoothCompaniesPage } from "../pages/BoothCompaniesPage";

/** Visitor / participant client app (MAX mini-app, web, future native shell). */
export const clientRouter = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      // IDEA-041: app.mvk.ru / = entry chooser (same as /go)
      { index: true, Component: EntryChooserPage },
      { path: "login", Component: VisitorLoginPage },
      { path: "start", Component: EntryChooserPage },
      { path: "go/t/:token", Component: TicketInvitePage },
      { path: "go/booth/:eventId/:companyId", Component: QrGatewayPage },
      { path: "go/booth-slot/:eventId/:booth", Component: QrGatewayPage },
      { path: "go/company/:companyId", Component: QrGatewayPage },
      { path: "go/badge/:repId", Component: QrGatewayPage },
      { path: "go/product/:productId", Component: QrGatewayPage },
      { path: "go/c/:code", Component: QrGatewayPage },
      { path: "go", Component: EntryChooserPage },
      { path: "onboarding", Component: OnboardingPage },
      { path: "home", Component: HomePage },
      { path: "guide", Component: GuidePage },
      { path: "search", Component: SearchPage },
      { path: "map", Component: MapPage },
      { path: "my", Component: ProfilePage },
      { path: "my/booth-qr", Component: BoothSharePage },
      { path: "support", Component: SupportChatPage },
      { path: "companies", Component: CompaniesPage },
      { path: "chats", Component: ChatsPage },
      { path: "companies/:id", Component: CompanyDetailPage },
      { path: "companies/:id/products", Component: CompanyProductsPage },
      { path: "booths/:eventId/:booth", Component: BoothCompaniesPage },
      { path: "representatives/:id", Component: RepresentativeCardPage },
      { path: "products", Component: ProductsPage },
      { path: "products/:id", Component: ProductDetailPage },
      { path: "scan", Component: ScanPage },
      { path: "history", Component: HistoryPage },
      { path: "visitors/:id", Component: VisitorContactPage },
      { path: "card", Component: BusinessCardPage },
      { path: "events", Component: EventsPage },
      { path: "claim-badge", Component: ClaimExhibitorBadgePage },
      { path: "schedule", Component: SchedulePage },
      { path: "schedule/:id", Component: SessionDetailPage },
      { path: "favorites", Component: FavoritesPage },
      { path: "exhibitor/dashboard", Component: ExhibitorDashboard },
      { path: "exhibitor/leads", Component: ExhibitorLeadsPage },
      { path: "exhibitor/leads/:id", Component: LeadDetailPage },
      { path: "*", loader: () => redirect("/") },
    ],
  },
]);
